import { FirmSettings } from "..";

export const FirmOptionsPrefix = "firm-options/emails/";

export const EmailTypes = {
    ASSIGN_SEARCH: "search request assigned",
    COMPLETE_SEARCH: "search request completed",
    HITS_SHARED: "email for reviewers",
    DEFAULT: "default email notification"
} as const;

type emailSettingsPath =
    | (FirmSettings.FieldPath & "firm-options/emails/enableEmailNotificationsWhenAssigned")
    | "firm-options/emails/enableEmailNotificationsWhenCompleted"
    | "firm-options/emails/enableEmailNotificationsWhenHitsShared"
    | "firm-options/emails/enableEmailNotifications";

export const EmailSettingsPathMap = new Map<(typeof EmailTypes)[keyof typeof EmailTypes], emailSettingsPath>([
    [EmailTypes.ASSIGN_SEARCH, `${FirmOptionsPrefix}enableEmailNotificationsWhenAssigned`],
    [EmailTypes.COMPLETE_SEARCH, `${FirmOptionsPrefix}enableEmailNotificationsWhenCompleted`],
    [EmailTypes.HITS_SHARED, `${FirmOptionsPrefix}enableEmailNotificationsWhenHitsShared`],
    [EmailTypes.DEFAULT, `${FirmOptionsPrefix}enableEmailNotifications`]
]);
